export default "__VITE_ASSET__58ebaa72__"